import React from "react";

export default function StatusBadge({ status }) {

    const s = String(status || "").toLowerCase();

    let cls =
        "bg-slate-100 text-slate-700";

    if (
        s.includes("online") ||
        s.includes("verified") ||
        s.includes("success") ||
        s.includes("delivered") ||
        s.includes("encrypted")
    )
        cls = "bg-green-100 text-green-700";

    else if (
        s.includes("pending") ||
        s.includes("warning")
    )
        cls = "bg-yellow-100 text-yellow-700";

    else if (
        s.includes("offline") ||
        s.includes("error") ||
        s.includes("failed") ||
        s.includes("danger")
    )
        cls = "bg-red-100 text-red-700";

    else if (
        s.includes("processing")
    )
        cls = "bg-blue-100 text-blue-700";

    return (
        <span
            className={`
                inline-flex
                px-3
                py-1
                rounded-full
                text-sm
                font-semibold
                ${cls}
            `}
        >
            {status}
        </span>
    );
}